

































import ScrollPane from './ScrollPane.vue';
// import { generateTitle } from "@/utils/i18n";
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import path from 'path';
import { RouteConfig } from 'vue-router';
import { PermissionModule } from '@/store/modules/permission';

interface TagItem {
  fullPath: string;
  path: string;
  name?: string;
  meta: any;
}

@Component({
  components: {
    ScrollPane,
  },
})
export default class TagsView extends Vue {
  private visible: boolean = false;
  private top: number = 0;
  private left: number = 0;
  private selectedTag = {};
  private affixTags: TagItem[] = [];

  public get visitedViews(): any {
    return this.$store.state.tagsView.visitedViews;
  }

  public get routes(): RouteConfig[] {
    return  PermissionModule.routes;
  }
  @Watch('$route')
  public onRouteChanged(val: string, oldVal: string) {
    this.addTags(), this.moveToCurrentTag();
  }

  @Watch('visible')
  public onVisibleChanged(val: string, oldVal: string) {
    if (val) {
      document.body.addEventListener('click', this.closeMenu);
    } else {
      document.body.removeEventListener('click', this.closeMenu);
    }
  }

  public mounted() {
    this.initTags();
    this.addTags();
  }

  private isActive(route: RouteConfig) {
    return route.path === this.$route.path;
  }

  private filterAffixTags(routes: RouteConfig[], basePath = '/') {
    let tags: TagItem[] = [];
    routes.forEach((route) => {
      if (route.meta && route.meta.affix) {
        const tagPath = path.resolve(basePath, route.path);
        tags.push({
          fullPath: tagPath,
          path: tagPath,
          name: route.name,
          meta: { ...route.meta },
        });
      }
      if (route.children) {
        const tempTags = this.filterAffixTags(route.children, route.path);
        if (tempTags.length >= 1) {
          tags = [...tags, ...tempTags];
        }
      }
    });
    return tags;
  }
  private initTags() {
    const affixTags = (this.affixTags = this.filterAffixTags(this.routes));
    for (const tagView of affixTags) {
      // Must have tag name
      if (tagView.name) {
        this.$store.dispatch('addVisitedView', tagView);
      }
    }
  }

  private generateTitle(title: string) {
    // return "test_" + title

    const hasKey = this.$te('route.' + title);

    if (hasKey) {
      // $t :this method from vue-i18n, inject in @/lang/index.js
      const translatedTitle = this.$t('route.' + title);

      return translatedTitle;
    }
    return title;
  }

  private moveToCurrentTag() {
    const tags = this.$refs.tag as any;
    this.$nextTick(() => {
      const scrollPane = this.$refs.scrollPane as ScrollPane;
      console.log(tags)
      for (const tagView of tags) {
        if (tagView.to.path === this.$route.path) {
          scrollPane.moveToTarget(tagView);
          // when query is different then update
          if (tagView.to.fullPath !== this.$route.fullPath) {
            this.$store.dispatch('updateVisitedView', this.$route);
          }
          break;
        }
      }
    });
  }

  private refreshSelectedTag(view: any) {
    this.$store.dispatch('delCachedView', view).then(() => {
      const { fullPath } = view;
      this.$nextTick(() => {
        this.$router.replace({
          path: '/redirect' + fullPath,
        });
      });
    });
  }

  private closeSelectedTag(view: any) {
    this.$store.dispatch('delView', view).then(({ visitedViews }) => {
      if (this.isActive(view)) {
        this.toLastView(visitedViews);
      }
    });
  }

  private closeOthersTags() {
    this.$router.push(this.selectedTag);
    this.$store.dispatch('delOthersViews', this.selectedTag).then(() => {
      this.moveToCurrentTag();
    });
  }

  private closeAllTags(view: any) {
    this.$store.dispatch('delAllViews').then(({ visitedViews }) => {
      if (this.affixTags.some((tagView) => {
        return tagView.path === view.path;
      })) {
        return;
      }
      this.toLastView(visitedViews);
    });
  }

  private toLastView(visitedViews: any) {
    const latestView = visitedViews.slice(-1)[0];
    if (latestView) {
      this.$router.push(latestView);
    } else {
      // You can set another route
      this.$router.push('/');
    }
  }

  private openMenu(tagsView: any, e: any) {
    const menuMinWidth = 105;
    const offsetLeft = this.$el.getBoundingClientRect().left; // container margin left
    const offsetWidth = (this.$el as any).offsetWidth; // container width
    const maxLeft = offsetWidth - menuMinWidth; // left boundary
    const left = e.clientX - offsetLeft + 15; // 15: margin right

    if (left > maxLeft) {
      this.left = maxLeft;
    } else {
      this.left = left;
    }

    this.top = e.clientY;
    this.visible = true;
    this.selectedTag = tagsView;
  }

  private addTags() {
    const { name } = this.$route;
    if (name) {
      this.$store.dispatch('addView', this.$route);
    }
    return false;
  }

  private closeMenu() {
    this.visible = false;
  }
}
